export default __webpack_public_path__ + "static/media/s-squiggle-131.ddd1025c.svg";